import type { Vertical } from "../types/vertical";

export const verticals: Vertical[] = [
  {
    path: "/beauty",
    status: "Primeira vertical",
    title: "Beauty",
    promise: "Agenda, cliente, atendimento, falta sem aviso, reputação e base para comissão sob controle.",
    mode: "Disponivel primeiro"
  },
  {
    path: "/health",
    status: "Evolucao controlada",
    title: "Health",
    promise: "Paciente, retorno, continuidade e visao de recepcao sem virar prontuario medico completo.",
    mode: "Acesso futuro"
  },
  {
    path: "/legal",
    status: "Evolucao controlada",
    title: "Legal",
    promise: "Carteira, caso, prazo, próximo passo e relacionamento com menos risco operacional.",
    mode: "Acesso futuro"
  },
  {
    path: "/oficinas",
    status: "Candidata em validação",
    title: "Oficinas",
    promise: "OS, veiculo, checklist, fotos, status e rastreabilidade da entrada a entrega.",
    mode: "Validacao"
  }
];
